import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Cookies from "js-cookie";
import { useForm } from "react-hook-form";
import "bootstrap/dist/css/bootstrap.min.css";
// import StartUpScreen from "./StartUpScreen";  // Adjust import path
// import Loader from "./Loader";  // Adjust import path
import { communication } from "../services/communication";
import StartUpScreen from "./StartUpScreen";
import Loader from "./Loader";

const Login = () => {
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    try {
      setLoader(true);

      // Send login request
      const serverResponse = await communication.login(data);
      if (serverResponse?.data?.status === "SUCCESS") {
        Cookies.set("userToken", serverResponse?.data?.token);
        Cookies.set("userDetails", JSON.stringify(serverResponse?.data?.data));

        Swal.fire({
          text: serverResponse?.data?.message,
          icon: "success",
          timer: 2000,
        });

        navigate("/main-panel/user-management");
      } else {
        Swal.fire({
          text: serverResponse?.data?.message,
          icon: "error",
        });
      }
      setLoader(false);
    } catch (error) {
      Swal.fire({
        text: error?.response?.data?.message || error.message,
        icon: "warning",
      });
      setLoader(false);
    }
  };

  return (
    <>
      {loader ? (
        <Loader />
      ) : (
        <div className="container-fluid login_main">
          <div className="row">
            <div className="col-6">
              <StartUpScreen />
            </div>

            <div className="col-6 right">
              <div className="form_container">
                <div className="form_wrapper">
                  <div className="form_submit">
                    <h1>Login</h1>

                    <div className="mt-4 mb-3">
                      <input
                        {...register("userId", {
                          required: "User ID is required",
                        })}
                        placeholder="Enter User ID"
                        type="text"
                        className="form-control input login_input"
                      />
                      {errors.userId && (
                        <p className="text-danger text-start">{errors.userId.message}</p>
                      )}
                    </div>

                    <div className="mt-4 mb-3">
                      <input
                        {...register("password", {
                          required: "Password is required",
                          minLength: {
                            value: 6,
                            message: "Password must be at least 6 characters long",
                          },
                        })}
                        placeholder="Enter Password"
                        type="password"
                        className="form-control input login_input"
                      />
                      {errors.password && (
                        <p className="text-danger text-start">{errors.password.message}</p>
                      )}
                    </div>

                    <button
                      onClick={handleSubmit(onSubmit)}
                      type="submit"
                      className="btn btn-primary button my-2"
                    >
                      Login
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Login;
